/**
 * Opens the browser native date/month picker for an input element.
 */
export function openNativeDateInput(el) {
  if (!el || el.disabled) return;
  if (typeof el.showPicker === "function") {
    try {
      el.showPicker();
      return;
    } catch {
      /* ignore — e.g. not triggered by user gesture in some browsers */
    }
  }
  el.focus();
  el.click();
}
